import React, { useContext } from "react"
import LocaleContext from "../../context/LocaleContext"
import translate, { keys } from "../../translation/translator"
import HealthyLifeSectionStyle from "./styles/HealthyLifeSectionStyle.module.styl"
import { Link } from "gatsby"

const HealthyLifeSection = () => {
  const locale = useContext(LocaleContext).locale
  return (
    <div className={HealthyLifeSectionStyle.wrapper}>
      <div className={HealthyLifeSectionStyle.holder}>
        <h2 className={HealthyLifeSectionStyle.title}>
          {translate(keys.INDEX_HLTH_LIFE_U_WANT_LEAD, locale)}{" "}
          <span>{translate(keys.INDEX_HLTH_LIFE_HEALTHY_LIFE, locale)}</span>
        </h2>
        <h3 className={HealthyLifeSectionStyle.description}>
          {translate(keys.INDEX_HLTH_LIFE_DESC, locale)}{" "}
        </h3>
        <Link
          to="/nai-dobri-sveti-za-novodiagnosticirani-diabetici/"
          className={HealthyLifeSectionStyle.link}
        >
          {translate(keys.INDEX_HLTH_LIFE_FIRST_STEPS_BTR_LIFE, locale)}
        </Link>
      </div>
    </div>
  )
}

export default HealthyLifeSection
